import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { black, red } from '../../utils/style/colors';
import { convertDigitToProperFormat } from '../../utils/number';
import messages from './messages';

interface TimeLeft {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

interface CountdownTimerProps {
  targetTime: number;
}

const TimerContainer = styled.div<{ isAlmostDone: boolean }>`
  border-radius: 20px;
  background-color: var(--exact-white);
  padding: 10px;
  width: 120px;
  margin: auto;
  display: flex;
  justify-content: center;
  font-weight: 700;
  color: ${(props) => (props.isAlmostDone ? red : black)};
`;

const CountdownTimer: React.FC<CountdownTimerProps> = ({ targetTime }) => {
  const calculateTimeLeft = (): TimeLeft => {
    const difference = targetTime - new Date().getTime();
    let timeLeft: TimeLeft = {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    };

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState<TimeLeft>(calculateTimeLeft());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearTimeout(timer);
  });

  const isAlmostDone = timeLeft.minutes <= 5;

  return (
    <TimerContainer isAlmostDone={isAlmostDone}>
      <span>
        {!!timeLeft.days &&
          convertDigitToProperFormat(timeLeft.days.toString())}
        {!!timeLeft.days && messages.days}
        {convertDigitToProperFormat(timeLeft.hours.toString().padStart(2, '0'))}
        :
        {convertDigitToProperFormat(
          timeLeft.minutes.toString().padStart(2, '0')
        )}
        :
        {convertDigitToProperFormat(
          timeLeft.seconds.toString().padStart(2, '0')
        )}
      </span>
    </TimerContainer>
  );
};

export default CountdownTimer;
